// tabs/CustomerInsightsTab.jsx

import { formatInReal } from "../../../../../commons/util/HallAppUtil";

export default function CustomerInsightsTab({ stats }) {
  return (
    <div className="hc-cd-panel">
      <div className="hc-cd-panel__title">Insights rápidos</div>

      <div className="hc-cd-grid">
        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Total gasto</div>
          <div className="hc-cd-gridCard__value">{formatInReal(stats.totalSpent)}</div>
        </div>

        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Total de visitas (filtro atual)</div>
          <div className="hc-cd-gridCard__value">{stats.totalVisits}</div>
        </div>

        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Ticket médio</div>
          <div className="hc-cd-gridCard__value">{formatInReal(stats.avgTicket)}</div>
        </div>

        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Média de visitas / mês</div>
          <div className="hc-cd-gridCard__value">{stats.avgPerMonth}</div>
        </div>

        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Última visita (histórico filtrado)</div>
          <div className="hc-cd-gridCard__value">{stats.lastVisitDate || "—"}</div>
        </div>

        <div className="hc-cd-gridCard">
          <div className="hc-cd-gridCard__label">Melhor mês (por gasto)</div>
          <div className="hc-cd-gridCard__value">
            {stats.bestMonth ? `${stats.bestMonth} • ${formatInReal(stats.bestMonthValue)}` : "—"}
          </div>
        </div>
      </div>

      <div className="hc-cd-panel__hint">Os insights respeitam os filtros da aba “Visitas”.</div>
    </div>
  );
}
